@if (!deleted) {
    <div class="flex column root">
        @if (user$ | async; as user) {
            <div class="flex row">
                @if (user && isOwner) {
                    <div class="menu">
                        <button mat-icon-button [matMenuTriggerFor]="menu">
                            <mat-icon>more_vert</mat-icon>
                        </button>
                        <mat-menu #menu="matMenu">
                            <div>
                                <button mat-menu-item (click)="edit()">Edit</button>
                                <button mat-menu-item (click)="state = AnnotationState.Delete">
                                    Delete
                                </button>
                            </div>
                        </mat-menu>
                    </div>
                }

                <img src="{{ annotation.user.email | identicon | async }}" class="user-icon" [matTooltip]="annotation.user.name"/>
                <div class="column flex-80 info">
                    <div class="title">{{ annotation.user.name }}</div>
                    <div class="author">{{ annotation.created | dateAgo }}</div>
                </div>
            </div>
            @if (annotation.timestamp >= 0) {
                <small class="frame">Frame {{ frame }}</small>
            }
            @if (state === AnnotationState.Idle || state === AnnotationState.Reply) {
                <div [innerHTML]="annotation.comment | mention"></div>
            }

            <!-- Actions -->
            <div class="actions">
                @switch (state) {
                    @case (AnnotationState.Idle) {
                        <div class="reply">
                            <a (click)="state = AnnotationState.Reply">Reply</a>
                        </div>
                    }
                    @case (AnnotationState.Reply) {
                        <div>
                            <mat-form-field appearance="fill">
                                <mat-label>Add Reply</mat-label>
                                <textarea matInput [formControl]="contentControl"></textarea>
                            </mat-form-field>
                            <button mat-button (click)="state = AnnotationState.Idle">
                                Cancel
                            </button>
                            <button mat-stroked-button color="primary" (click)="reply()">
                                Post Reply
                            </button>
                        </div>
                    }
                    @case (AnnotationState.Delete) {
                        <div>
                            <p>Are you sure you want to delete this annotation?</p>
                            <button mat-button (click)="state = AnnotationState.Idle">
                                Cancel
                            </button>
                            <button mat-stroked-button color="warn" (click)="delete()">
                                Delete
                            </button>
                        </div>
                    }
                    @case (AnnotationState.Edit) {
                        <div>
                            <mat-form-field appearance="fill">
                                <mat-label>Edit Annotation</mat-label>
                                <textarea matInput [formControl]="contentControl"></textarea>
                            </mat-form-field>
                            <button mat-button (click)="state = AnnotationState.Idle">
                                Cancel
                            </button>
                            <button mat-stroked-button color="primary" (click)="save()">
                                Save
                            </button>
                        </div>
                    }
                }
            </div>

            @for (replyAnnotation of annotation.children; track replyAnnotation) {
                <div class="indent">
                    <frog-annotation-list-item [annotation]="replyAnnotation"></frog-annotation-list-item>
                </div>
            }
        }
    </div>
}
